import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "print-header__container"
}
const _hoisted_2 = { class: "print-header__title" }
const _hoisted_3 = { class: "print-header__branch-info" }
const _hoisted_4 = { key: 0 }

import { isPrintPreview } from '@helper/composables/printPreview';

interface Props {
	title?: string;
	address?: string;
	phone?: string;
	email?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PrintHeader',
  props: {
    title: { default: '' },
    address: { default: '' },
    phone: { default: '' },
    email: { default: '' }
  },
  setup(__props: any) {



const { printPreview } = isPrintPreview();

return (_ctx: any,_cache: any) => {
  return (_unref(printPreview))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.address), 1 /* TEXT */),
          (_ctx.phone)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Telefon " + _toDisplayString(_ctx.phone), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.email), 1 /* TEXT */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})